import {
  StaticFeatureEnum,
  PermissionVisibility,
  PermissionAccess,
} from '@wizeoo/akm-common-lib';

import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { WIZ_EVENT_TYPE, IWizTranslationEntry } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  WizTranslationBasic,
  WizEventManager, WizEvent,
  WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { ChronoCodeLevelVO } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

/**
 * rendu d'un niveau de FD-Level
 */
@Component({
  selector: 'chronocode-level-renderer',
  templateUrl: './chronocode-level.renderer.html',
})
export class ChronocodeLevelRenderer implements AfterViewInit, OnDestroy, IWizItemRenderer<null, ChronoCodeLevelVO> {
  @HostBinding('style.width') elwidth: string = '100%';

  @ViewChild('chronLevelTrans', { read: WizTranslationBasic }) chronLevelTrans: WizTranslationBasic;

  constructor(public cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  private _data: ChronoCodeLevelVO;
  public updatedEntry: IWizTranslationEntry = null;

  /**
   * Sets the data that needs to be rendered
   */
  @Input() public set data(value: ChronoCodeLevelVO) {
    this._data = value;
    this.cdref.markForCheck();
  }

  public get data(): ChronoCodeLevelVO {
    return this._data;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.chronLevelTrans.wizLabel =
        WizTranslationManager.getInstance().translateKey('$.chronocode.level.$') + ' ' + this.data.level;
      this.chronLevelTrans.translationData = Model.getInstance().localeEngine.buildTranslationData(this.data.labelVO);
      this.chronLevelTrans.wizDisabled = !Model.getInstance().permissionEngine.hasAnyPermission({
        feature: StaticFeatureEnum.CHRONOCODE,
        visibility: PermissionVisibility.DISABLED,
        accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
      });
    }, 0);
    WizEventManager.addListener(this, this.chronLevelTrans, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
  }

  ngOnDestroy() {
    if (!!this.chronLevelTrans) {
      // sinon, c'est qu'il est détruit avant le afterInit
      WizEventManager.removeListener(this, this.chronLevelTrans, WIZ_EVENT_TYPE.MODEL_UPDATE);
    }
  }

  private updateModel(e: WizEvent): void {
    this.updatedEntry = e.value;
    WizEventManager.dispatchEvent(this, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, null, this));
  }
}
